<template>
  <div ref="homeRef" class="home">
    <HeroSection />
    <PilaresSection id="pilares" />
    <MetricasSection />
    <JornadaSection id="jornada" />
    <CtaSection id="cta" />
    <FooterSection />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { gsap } from "gsap";
import HeroSection from "../components/HeroSection.vue";
import PilaresSection from "../components/PilaresSection.vue";
import MetricasSection from "../components/MetricasSection.vue";
import JornadaSection from "../components/JornadaSection.vue";
import CtaSection from "../components/CtaSection.vue";
import FooterSection from "../components/FooterSection.vue";

const homeRef = ref(null);
let ctx;

onMounted(() => {
  ctx = gsap.context(() => {}, homeRef.value);
});

onUnmounted(() => {
  if (ctx) ctx.revert();
});
</script>

<style scoped>
.home {
  position: relative;
}
</style>
